import React, { useState } from 'react';
import HungryPieceGame, { HUNGRY_CHAPTERS } from '../components/HungryPieceGame';
import KidsGameEngine from '../HomeworkKidsGames/KidsGameEngine';
import { BOOTCAMP_CLASSES } from '../utils/kidsBootcampData';

export default function Basics({ user }) {
    const [mode, setMode] = useState('bootcamp'); // 'basics' or 'bootcamp'
    const [selectedChapter, setSelectedChapter] = useState(null);
    const [selectedBootcampClass, setSelectedBootcampClass] = useState(null);

    const handleWin = () => {
        setTimeout(() => setSelectedChapter(null), 3000);
    };

    return (
        <div style={{width: '100%', maxWidth: '1000px', margin: '0 auto', padding: '10px 10px 40px 10px', boxSizing: 'border-box' }}>
            
            {/* Header banner */}
            <div className="glass-panel" style={{padding: '20px 25px', display: 'flex', alignItems: 'center', gap: '20px', marginBottom: '30px', border: '1px solid var(--border-glass)' }}>
                <div style={{fontSize: '40px', background: 'rgba(59, 130, 246, 0.1)', width: '65px', height: '65px', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '15px', border: '1px solid rgba(59, 130, 246, 0.3)' }}>
                    🐣
                </div>
                <div>
                    <h1 style={{color: 'var(--text-primary)', margin: 0, fontSize: '26px', letterSpacing: '0.5px' }}>Beginners Learning Zone</h1>
                    <p style={{color: 'var(--text-secondary)', margin: '3px 0 0 0', fontWeight: 'bold', fontSize: '14px' }}>Learn piece movements, safety zones, and key rules through interactive mini-games!</p>
                </div>
            </div>

            {/* Mode selection tabs */}
            {!selectedChapter && !selectedBootcampClass && (
                <div style={{display: 'flex', gap: '10px', marginBottom: '25px', borderBottom: '1px solid var(--border-glass)', paddingBottom: '15px' }}>
                    <button 
                        onClick={() => setMode('bootcamp')} 
                        className={mode === 'bootcamp' ? 'neu-btn-primary' : 'neu-btn'}
                        style={{fontSize: '15px', padding: '10px 25px' }}
                    >
                        🐣 Beginners Bootcamp (36 Classes)
                    </button>
                    <button 
                        onClick={() => setMode('basics')} 
                        className={mode === 'basics' ? 'neu-btn-primary' : 'neu-btn'}
                        style={{fontSize: '15px', padding: '10px 25px' }}
                    >
                        🍎 Hungry Piece Game
                    </button>
                </div>
            )}

            {/* Sub-view rendering */}
            {mode === 'basics' ? (
                // --- BASICS MODE ---
                !selectedChapter ? (
                    <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '15px' }}>
                        {HUNGRY_CHAPTERS.map((chapter) => (
                            <div key={chapter.id} onClick={() => setSelectedChapter(chapter.id)} className="neu-panel-inner" style={{padding: '20px', cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', border: '1px solid var(--border-glass)', boxShadow: 'var(--panel-shadow)' }}>
                                <h3 style={{margin: '0 0 5px 0', color: 'var(--text-primary)', fontSize: '20px' }}>{chapter.piece}</h3>
                                <div style={{fontSize: '12px', color: 'var(--text-secondary)', textAlign: 'center', marginBottom: '15px' }}>{chapter.levels.length} Levels</div>
                                <div className="neu-btn-primary" style={{padding: '8px 20px', fontSize: '13px', borderRadius: '6px' }}>Play ▶</div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="glass-panel" style={{padding: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center', border: '1px solid var(--border-glass)' }}>
                        <button onClick={() => setSelectedChapter(null)} className="neu-btn" style={{alignSelf: 'flex-start', marginBottom: '15px' }}>
                            ⬅️ Browse Pieces
                        </button>
                        
                        <HungryPieceGame 
                            initialChapter={selectedChapter} 
                            onWin={handleWin}
                            onChapterComplete={() => {}}
                        />
                    </div>
                )
            ) : (
                // --- BOOTCAMP MODE ---
                !selectedBootcampClass ? (
                    <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '20px' }}>
                        {BOOTCAMP_CLASSES.map((cls) => (
                            <div 
                                key={cls.id} 
                                onClick={() => setSelectedBootcampClass(cls.id)} 
                                className="neu-panel-inner" 
                                style={{padding: '20px', 
                                    cursor: 'pointer', 
                                    display: 'flex', 
                                    flexDirection: 'column', 
                                    gap: '10px', 
                                    border: '1px solid var(--border-glass)', 
                                    boxShadow: 'var(--panel-shadow)',
                                    background: 'var(--neu-inner)'
                                }}
                            >
                                <div style={{display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <span style={{fontSize: '32px' }}>{cls.icon}</span>
                                    <div>
                                        <h3 style={{margin: 0, color: 'var(--text-primary)', fontSize: '16px' }}>{cls.name}</h3>
                                        <span style={{color: '#3b82f6', fontSize: '11px', fontWeight: 'bold' }}>15 Challenges</span>
                                    </div>
                                </div>
                                <p style={{color: 'var(--text-secondary)', fontSize: '12px', lineHeight: '1.4', margin: '5px 0 10px 0' }}>{cls.desc}</p>
                                <div className="neu-btn-primary" style={{padding: '8px 16px', fontSize: '12px', borderRadius: '6px', textAlign: 'center', marginTop: 'auto' }}>
                                    Start Class ▶
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div style={{width: '100%' }}>
                        <KidsGameEngine 
                            assignment={{
                                id: `bootcamp_class_${selectedBootcampClass}`,
                                levelId: `KIDS_bootcamp_${selectedBootcampClass}`,
                                title: `Class ${selectedBootcampClass} Practice`,
                                assignmentDocId: 'INDIVIDUAL' // Bypasses Firestore submissions
                            }}
                            myProfile={{
                                email: user.email,
                                name: user.displayName || user.email.split('@')[0]
                            }}
                            onBack={() => setSelectedBootcampClass(null)}
                        />
                    </div>
                )
            )}
            
        </div>
    );
}
